"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSRDataInjector = void 0;
const jotai_1 = require("jotai");
const react_1 = require("react");
const react_2 = require("@remix-run/react");
const common_1 = require("./common");
const CSRDataInjector = (props) => {
    const store = (0, jotai_1.useStore)();
    const matches = (0, react_2.useMatches)();
    const ids = (0, react_1.useRef)(new Set());
    const isHydrating = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (isHydrating.current) {
            isHydrating.current = false;
            return;
        }
        const pendingAtoms = [];
        matches.forEach((m) => {
            const data = m.data;
            const dataLoaderId = data?.__id__ || null;
            // 根据 root loader 去重
            if (dataLoaderId && ids.current.has(dataLoaderId)) {
                return;
            }
            if (dataLoaderId) {
                ids.current.add(dataLoaderId);
            }
            for (const key in data) {
                if (!key.startsWith('$')) {
                    continue;
                }
                const atom = (0, common_1.getAtom)(props, key);
                const atomData = data[key];
                pendingAtoms.push([atom, atomData]);
            }
        });
        if (pendingAtoms.length) {
            pendingAtoms.forEach(([atom, atomData]) => store.set(atom, atomData));
        }
    }, [matches]);
    return null;
};
exports.CSRDataInjector = CSRDataInjector;
